import { useMemo } from 'react';

import ProductCardSkeletonC from '~/components/ProductCardV3/skeletons/ProductCardSkeletonC';
import ProductCardSkeletonM from '~/components/ProductCardV3/skeletons/ProductCardSkeletonM';
import ProductCardSkeletonS from '~/components/ProductCardV3/skeletons/ProductCardSkeletonS';
import ProductCardSkeletonXS from '~/components/ProductCardV3/skeletons/ProductCardSkeletonXS';

import { ProductCardSkeletonFactoryProps } from './types';

/**
 * ProductCardSkeletonFactory - Factory component that renders appropriate skeleton variant
 * based on the `variant` prop (m, s, xs, or c)
 */
const ProductCardSkeletonFactory = ({
  variant,
  ...props
}: ProductCardSkeletonFactoryProps) => {
  const SkeletonComponent = useMemo(() => {
    switch (variant) {
      case 'm':
        return ProductCardSkeletonM;
      case 's':
        return ProductCardSkeletonS;
      case 'xs':
        return ProductCardSkeletonXS;
      case 'c':
        return ProductCardSkeletonC;
      default:
        return ProductCardSkeletonM;
    }
  }, [variant]);

  return <SkeletonComponent {...props} />;
};

export default ProductCardSkeletonFactory;
